// src/services/transfer.service.js
import axios from "../utils/axios.wrapper";

// Get all transfers
export const getAllTransfers = async () => {
  const { data } = await axios.get("/transfer");
  return data;
};

// Get active transfers
export const getActiveTransfers = async () => {
  const { data } = await axios.get("/transfer/active");
  return data.items || data;
};

// Get inactive transfers
export const getInactiveTransfers = async () => {
  const { data } = await axios.get("/transfer/inactive");
  return data.items || data;
};

// Get transfer by ID
export const getTransferById = async (id) => {
  const { data } = await axios.get(`/transfer/${id}`);
  return data;
};

// Get transfers by from-shop
export const getTransfersByFromShop = async (shopId) => {
  const { data } = await axios.get(`/transfer/from-shop/${shopId}`);
  return data.items || data;
};

// Get transfers by to-shop
export const getTransfersByToShop = async (shopId) => {
  const { data } = await axios.get(`/transfer/to-shop/${shopId}`);
  return data.items || data;
};

// Get transfers by status
export const getTransfersByStatus = async (statusId) => {
  const { data } = await axios.get(`/transfer/status/${statusId}`);
  return data.items || data;
};

// Get transfers by date range
export const getTransfersByDateRange = async (startDate, endDate) => {
  const { data } = await axios.post("/transfer/daterange", { startDate, endDate });
  return data.items || data;
};

// Create new transfer
export const createTransfer = async (transferData) => {
  const { data } = await axios.post("/transfer/create", transferData);
  return data;
};

// Update transfer
export const updateTransfer = async (id, transferData) => {
  const { data } = await axios.put(
    `/transfer/${id}`,
    transferData,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return data;
};

// Soft delete transfer
export const deleteTransfer = async (id) => {
  const { data } = await axios.delete(`/transfer/${id}`);
  return data;
};

// Hard delete transfer
export const hardDeleteTransfer = async (id) => {
  const { data } = await axios.delete(`/transfer/hard/${id}`);
  return data;
};

// (Exemple de search si tu fais une recherche custom côté front)
export const searchTransfers = async (predicate) => {
  // Ici tu peux juste filtrer en front après un getAllTransfers
  const all = await getAllTransfers();
  const items = all.items || all;
  return items.filter(predicate);
};

// Receive transfer
export const receiveTransfer = async (id, transferData) => {
  const { data } = await axios.post(`/transfer/${id}/receive`, transferData);
  return data;
};

// Cancel transfer
export const cancelTransfer = async (id) => {
  const { data } = await axios.put(`/transfer/cancel/${id}`);
  return data;
};



export const transferService = {
  getAllTransfers,
  getActiveTransfers,
  getInactiveTransfers,
  getTransferById,
  getTransfersByFromShop,
  getTransfersByToShop,
  getTransfersByStatus,
  getTransfersByDateRange,
  createTransfer,
  updateTransfer,
  deleteTransfer,
  hardDeleteTransfer,
  searchTransfers,
  receiveTransfer,
  cancelTransfer,
};
